import cn from 'classnames';
import { CloseIcon } from '#assets/ReactSvg.ts';
import pillStyles from './Pill.module.css';
import styles from './PillRemovable.module.css';

type Props = React.ComponentPropsWithRef<'button'> & {
  variant?: 'default' | 'alert' | 'success';
  size?: 'small' | 'large';
  children?: React.ReactNode;
  className?: string;
  onRemove: () => void;
};

/**
 * A pill that is rendered as a button with a close icon.  Intended to be used for cases where clicking on the pill removes it.
 */
export function PillRemovable({
  variant = 'default',
  size = 'small',
  children,
  onRemove,
  className,
  onClick,
  ...buttonProps
}: Props) {
  const classes = cn(
    styles.PillRemovable,
    pillStyles.Pill,
    pillStyles[`Pill___${variant}`],
    pillStyles[`Pill___${size}`],
    className
  );

  // When composed via an ariakit `render` prop (e.g. TagPillRemovable's tooltip), ariakit injects
  // its own onClick — compose it with onRemove rather than letting one clobber the other.
  return (
    <button
      type="button"
      className={classes}
      {...buttonProps}
      onClick={(event) => {
        onClick?.(event);
        onRemove();
      }}
    >
      <span className="visually-hidden">Clear</span>
      <span className="truncate">{children}</span>
      <CloseIcon className="shrink-0" aria-hidden="true" width={10} height={10} />
    </button>
  );
}
